<template>
  <v-card>
    <v-card-title>
      Create user
    </v-card-title>
    <v-card-text>
      <v-form v-model="valid" ref="form">
        <v-text-field
          label="Name"
          v-model="formData.name"
          ></v-text-field>
        <v-text-field
          label="Password"
          v-model="formData.password"
          type="password"
          v-if="!this.user"
          :rules="passwordRules"
          required></v-text-field>
        <v-text-field
          label="Email"
          v-if="!this.user"
          v-model="formData.email"
          type="email"
          :rules="emailRules"
          @blur="checkEmail"
          required></v-text-field>
      <v-radio-group v-model="formData.role">
        <v-radio label="Suites" :value="3"></v-radio>
        <v-radio label="Sales" :value="0"></v-radio>
        <v-radio label="Operations" :value="1"></v-radio>
        <v-radio label="Admin" :value="2"></v-radio>
      </v-radio-group>
      <v-checkbox v-model="formData.isSubscribed" :value="1" label="Email Subscription list"></v-checkbox>
      </v-form>
    </v-card-text>
    <v-alert color="error" icon="warning" v-if="err" :value="err !== ''">
      {{err}}
    </v-alert>
    <v-layout column align-end class="px-2">
      <a
        @click.prevent="submit"
        class="modal-button black--text"
        :disabled="!valid">
        <v-btn :disabled="!valid" fab dark small color="primary">
          <v-icon dark>arrow_forward</v-icon>
        </v-btn>
        Submit
      </a>  
      <a
        @click.prevent="$emit('close')"
        class="modal-button black--text">
        <v-btn fab dark small color="accent">
          <v-icon dark>close</v-icon>
        </v-btn>
        Close
      </a>
    </v-layout>
  </v-card>
</template>

<script>
  import webHelper from '../../helpers/web';

  export default {
    props: ['user', 'index'],
    data: () => ({
      valid: true,
      formData: {
        name: '',
        password: '',
        email: '',
        isSubscribed: false,
        role: null,
      },
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 35) || 'Name must be less than 35 characters',
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 6 && v.length <= 35) || 'Password must be longer than 6 and shorter than 35 characters',
      ],
      emailRules: [
        v => !!v || 'Email is required',
        // eslint-disable-next-line
        v => (v && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v.toLowerCase())) || 'Email is not valid',
      ],
      err: '',
    }),
    methods: {
      async checkEmail() {
        this.err = '';
        const where = {};
        where.email = this.formData.email;
        if (this.user) {
          where.id = this.user._id;
        }
        const res = await webHelper.get(this, 'user/email', where);
        if (res.failed || !res.isAvailable) {
          this.err = 'Email You chose is already taken.';
        }
      },
      async submit() {
        this.formData.isSubscribed = this.formData.isSubscribed === 1 ? 1 : 0;
        const method = this.user ? 'put' : 'post';
        const res = await webHelper[method](this, 'user', this.formData);
        if (res.failed) {
          this.err = 'Failed to create user';
          return;
        }
        delete this.formData.password;
        this.formData._id = this.user ? this.user._id : res.id;
        const event = this.user ? 'editUser' : 'pushUser';
        const data = this.user ? {
          user: this.formData,
          index: this.index,
        } : this.formData;
        this.$store.dispatch(event, data);
        this.$emit('close');
      },
    },
    created() {
      if (this.user) {
        this.formData.name = this.user.name;
        this.formData.password = this.user.password;
        this.formData.email = this.user.email;
        this.formData.isSubscribed = this.user.isSubscribed ? 1 : 0;
        this.formData.role = this.user.role;
        this.formData.id = this.user._id;
      }
    },
  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/modals/User.vue